import { DeliveryModeCode } from "@anu-its/cat-grpc-pb/js/anu/cat_app/enums_pb";

export const deliveryModeNames = (deliveryModeCode: DeliveryModeCode) =>
  ({
    [DeliveryModeCode.UNSPECIFIED]: "Unspecified",
    [DeliveryModeCode.INPERSON_AND_ONLINE]: "In Person and Online",
    [DeliveryModeCode.ONLINE]: "Online",
    [DeliveryModeCode.ONLINE_OR_INPERSON]: "Online or In Person",
    [DeliveryModeCode.INPERSON]: "In Person",
  })[deliveryModeCode];
